import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from '@node-space/ui-components'
import { logError } from '@node-space/utils'
import { DurationInMilliseconds } from 'constants/General'
import { changeCurrencyPref } from 'services/UserDetailsService'

export const useCurrency = () => {
  const { t } = useTranslation()
  const [isCurrencyEditing, setIsCurrencyEditing] = useState(false)
  const [currency, setCurrency] = useState<string | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const handleSaveCurrency = async () => {
    if (!currency) {
      setIsCurrencyEditing(false)
      return
    }

    try {
      setIsLoading(true)
      await changeCurrencyPref(currency)
      toast({ header: t('account.currencyChanged'), variant: 'success' })
    } catch (error) {
      const {
        data: { errorList },
      } = error
      const errorMessage = `${errorList?.[0]?.message}`
      errorMessage &&
        toast({
          header: errorMessage,
          variant: 'error',
          duration: DurationInMilliseconds.TWENTY_SECONDS,
        })
      logError(`Error from DisplaySettings - onSave`, error)
    } finally {
      setIsLoading(false)
      setIsCurrencyEditing(false)
    }
  }

  return {
    isCurrencyEditing,
    setCurrency: (currency: string) => setCurrency(currency),
    setIsCurrencyEditing: (isCurrencyEditing: boolean) => setIsCurrencyEditing(isCurrencyEditing),
    isChangingCurrency: isLoading,
    handleSaveCurrency,
  }
}
